import type { ModuleWithProviders } from '@angular/core';
import { NgModule } from '@angular/core';
import { DateLocalePipe } from './date-locale.pipe';
import { CurrencyLocalePipe } from './currency-locale.pipe';
import { AgePipe } from './age.pipe';
import { AuthenticatedUrlPipe } from './authenticated-url.pipe';

@NgModule({
  declarations: [
    DateLocalePipe,
    CurrencyLocalePipe,
    AgePipe,
    AuthenticatedUrlPipe
  ],
  exports: [
    DateLocalePipe,
    CurrencyLocalePipe,
    AgePipe,
    AuthenticatedUrlPipe
  ]
})
export class PipesModule {
  static forRoot(): ModuleWithProviders<PipesModule> {
    return {
      ngModule: PipesModule
    };
  }
}
